"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_logger_1 = __importDefault(require("js-logger"));
const initialConfig = {
    rtcPeerConnectionOptions: {}
};
const Config = Object.assign({}, initialConfig);
exports.setConfig = (c) => {
    for (const key in c) {
        Config[key] = c[key];
    }
    js_logger_1.default.info('Remoting configuration settings initialized:', Config);
    return Config;
};
exports.default = Config;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/config.js
// module id = 229
// module chunks = 0